// extracted by mini-css-extract-plugin
export default {"header_wrapper":"Header_header_wrapper__zbN8I","title":"Header_title__x3ga3"};